<div class="card">
    <div class="card-body p-5">
        <div class="row">
            <a class="col-sm-4 col-md-4 index-item" [routerLink]="['users']">
                <i class="fa fa-users"></i> Utilisateurs
            </a>
        </div>
    </div>
</div>